// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuthMethodController from "./auth_method_controller"
application.register("auth-method", AuthMethodController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ColumnVisibilityController from "./column_visibility_controller"
application.register("column-visibility", ColumnVisibilityController)

import ComingSoonController from "./coming_soon_controller"
application.register("coming-soon", ComingSoonController)

import ConsoleModeController from "./console_mode_controller"
application.register("console-mode", ConsoleModeController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FlightMatrixController from "./flight_matrix_controller"
application.register("flight-matrix", FlightMatrixController)

import GlobeController from "./globe_controller"
application.register("globe", GlobeController)

import IndeterminateController from "./indeterminate_controller"
application.register("indeterminate", IndeterminateController)

import InlineRowsEditorController from "./inline_rows_editor_controller"
application.register("inline-rows-editor", InlineRowsEditorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import PassportScanController from "./passport_scan_controller"
application.register("passport-scan", PassportScanController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SidebarNavController from "./sidebar_nav_controller"
application.register("sidebar-nav", SidebarNavController)

import SubmitOnChangeController from "./submit_on_change_controller"
application.register("submit-on-change", SubmitOnChangeController)

import TextExtractionPanelController from "./text_extraction_panel_controller"
application.register("text-extraction-panel", TextExtractionPanelController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)
